import styled from 'styled-components';
import Colors from "constants/Colors";
import { Breakpoints } from "constants/Breakpoints";
import { Text } from 'components/Text';
import { Col, Row } from "..//Grid";

export const ContainerTableCoverage = styled.div`
    width: 66%;
`

export const HeadCoverage = styled.div`
  color: #FFF;
  font-size: 20px;
  font-weight: 700;
  background-color: ${Colors.PURPLE};
  border: 1px solid ${Colors.PURPLE};
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 16px;
`

export const BodyCoverage = styled.div`
  padding: 16px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: 0px 8px 4px rgba(0, 0, 0, 0.1);
`
export const RowCoverage = styled.div`
  display: flex;
  flex-flow: wrap;
`
export const ExtraText = styled.div`
  width: 100%;
  display: flex;
  flex-flow: wrap;
  text-align: end;
  justify-content: flex-end;
  align-items: center;
  padding: 10px 10px;
`

export const ValueCoverage = styled.div`
  margin-right: 10px;
  margin-bottom: 15px;
`

export const TitleColumnCoverage = styled.span`
  display: block;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 40px;
  margin-right: 10px;
  width: ${((props) => props.width ? props.width : '100%')}
`


export const TableComponent = styled.table`
  padding: 0;
  width: 100%;

  border-collapse: separate;
  border-spacing: 10px 0;
`

export const TableHead = styled.thead`
  @media screen and (max-width: 600px) {     
    position: absolute;
  }
`

export const TableRow = styled.tr`
  vertical-align: middle;
  
  ${({ noBorder }) => noBorder ? '' : ` border-bottom: 1px solid ${Colors.GRAY[3]}`}
  ${({ backgroundColor }) => backgroundColor ? `background: ${backgroundColor}` : ''}
`;


export const TableHeader = styled.th`
  ${({ minWidth }) => minWidth ? `min-width: ${minWidth}px` : ''}
  ${({ backgroundColor }) => backgroundColor ? `background: ${backgroundColor}` : ''}
  position: relative;
  vertical-align: middle;
  padding-bottom: ${({paddingBottomControl}) => paddingBottomControl ? 'unset' : '10px'};
  padding-top: ${({paddingTopControl}) => paddingTopControl ? 'unset' : '10px'} ;
  padding-left: 0px;
  cursor: pointer;
  ${({ right }) => right ? 'text-align: right !important' : 'text-align: left'}
  span {
    font-size: 13px !important;
  }
  ${({ width }) => width ? `width: ${width}px` : ''}
  ${({ width }) => width ? `max-width: ${width}px` : ''}
`

export const TableBody = styled.tbody`
    @media screen and (max-width: ${Breakpoints.sm}) {
      top: 40px;
      position: relative;
    }
`;

export const TableColumn = styled.td`
  vertical-align: center;
  ${({ right }) => right ? 'text-align: right !important' : 'text-align: left'}
  ${({ center }) => center ? 'text-align: center !important' : ''}
  ${({ noBorder }) => noBorder ? '' : ` border-bottom: 1px solid ${Colors.GRAY[3]}`}
  ${({ noBorder }) => noBorder ? '' : ` border-left: 1px solid ${Colors.GRAY[3]}`}
  ${({ noBorder }) => noBorder ? '' : ` border-right: 1px solid ${Colors.GRAY[3]}`}
  ${({ width }) => width ? `width: ${width}px` : ''}
  ${({ width }) => width ? `max-width: ${width}px` : ''}

  padding-bottom: 10px;
  padding-top: 10px;
  padding-right: 10px;
  padding-left: 10px;
  display: table-cell;

  &:first-child {
    padding-left: 10px;
  }


  @media screen and (max-width: ${Breakpoints.sm}) {
    width: 100% !important;
    display: flex;
    max-width: unset !important;
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: left;

    &:last-child {
      padding-bottom: 10px;
    }

    &:first-child {
      padding-top: 10px;
    }
  }

  .icon-arrow-up-primary-color {
    width: 40px;
    height: 20px;
    min-width: 20px;
    transition: transform ease-in-out 200ms;
    
    &:before{
      background-size: 100%;
      width: 80%;
      height: 80%;
      margin: 10%;
    }
    
    &.closed {
      transform: rotate(180deg);
    }
  }
`;

export const TableColumnCoverageItem = styled.td`
  vertical-align: center;
  text-align: center;
  padding-bottom: 10px;
  padding-top: 10px;
  min-height: 62px;
  ${({ display }) => display ? `display: ${display}` : 'table-cell'}
  ${({ width }) => width ? `width: ${width}px` : ''}
  ${({ width }) => width ? `max-width: ${width}px` : ''}
  ${({ noBorder }) => noBorder ? '' : ` border-left: 1px solid ${Colors.GRAY[3]}`}
  ${({ noBorder }) => noBorder ? '' : ` border-right: 1px solid ${Colors.GRAY[3]}`}
  ${({ rightBorder }) => rightBorder ? ` border-left: 1px solid ${Colors.GRAY[3]}` : ''}
  align-items: center;

  &:first-child {
    padding-left: 10px;
  }

  &:last-child {
    border-right: 1px solid ${Colors.GRAY[3]};
  }

  @media screen and (max-width: ${Breakpoints.sm}) {
    border-right: 1px solid #C0C0C0;
    border-left: 1px solid #C0C0C0;
    display: flex;
    width: 100% !important;
    max-width: unset !important;
    padding-top: 0px;
    padding-bottom: 2px;
    text-align: left;

    &:last-child {
      padding-bottom: 10px;
    }

    &:first-child {
      padding-top: 10px;
    }
  }
`;

export const TableCollumCoverageName = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 0px;
`

export const TableCollumCoverageItem = styled.td`
  vertical-align: center;
  text-align: center;
  padding-bottom: 10px;
  padding-top: 10px;
  min-height: 62px;
  ${({ display }) => display ? `display: ${display}` : 'table-cell'}
  ${({ width }) => width ? `width: ${width}px` : ''}
  ${({ width }) => width ? `max-width: ${width}px` : ''}
  ${({ noBorder }) => noBorder ? '' : ` border-left: 1px solid ${Colors.GRAY[3]}`}
  ${({ noBorder }) => noBorder ? '' : ` border-right: 1px solid ${Colors.GRAY[3]}`}
  ${({ rightBorder }) => rightBorder ? ` border-left: 1px solid ${Colors.GRAY[3]}` : ''}
  align-items: center;

  &:first-child {
    padding-left: 10px;
  }

  &:last-child {
    border-right: 1px solid ${Colors.GRAY[3]};
  }

  @media screen and (max-width: ${Breakpoints.sm}) {
    border-right: 1px solid #C0C0C0;
    border-left: 1px solid #C0C0C0;
    display: flex;
    width: 100% !important;
    max-width: unset !important;
    padding-top: 0px;
    padding-bottom: 2px;
    text-align: left;

    &:last-child {
      padding-bottom: 10px;
    }

    &:first-child {
      padding-top: 10px;
    }
  }
`;


export const InlineLabel = styled(Text)`
  display: inline-block;
  width: 30%;
  vertical-align: middle;
  padding-right: 5px;
  justify-content: start;
  align-items: flex-start;
  justify-self: flex-start;
  text-align: left;
  font-size: 11px;
  color: ${Colors.GRAY[3]};
  font-weight: 700;

  @media screen and (min-width: 600px) {
    display: none;
  }
`;

export const RowValue = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-right: 10px;
  margin-left: 0px;
`;

export const SmallTitle = styled.h3`
  line-height: 20px;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 10px;
  margin-top: 10px;
  width: 100%;
`;

export const TextButton = styled.span`
  font-size: 14px;
  color: #666666;
  font-weight: bold;
`;

export const TitleAlter = styled.span`
  color: ${Colors.YELLOW};
  font-weight: 700;
  font-size: 16px;
  cursor: pointer;
  text-align: right;
  float: right;
  text-transform: uppercase;
`;

export const AddModalityContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: auto;
  align-items: center;
  cursor: pointer;
`;

export const AddButton = styled.div`
  color: white;
  font-size: 22px;
  text-align: center;
  width:25px;
  height:25px;
  border: 0px;
  border-radius: 25px;
  background-color: #53565a;
  cursor: pointer;
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 15px;
`
export const ContractContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100px;
  margin-left: auto;
  margin-right: auto;
`;